/**
 * WeaveIcon — brand icon for "AI with Weave".
 * Derived from the official Weave mark: two white horizontal strands interlaced
 * with two coral vertical strands in an over-under 2×2 weave pattern.
 *
 * Rendered stroke-based (lucide style) so it inherits currentColor and className
 * sizing — use it anywhere a lucide icon would appear.
 */
export function WeaveIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Horizontal strand 1 (y=9): on top at V1(x=7), gap where V2(x=17) is on top */}
      <path d="M3 9h12M19 9h2" />
      {/* Horizontal strand 2 (y=15): on top at V2(x=17), gap where V1(x=7) is on top */}
      <path d="M3 15h2M9 15h12" />
      {/* Vertical strand 1 (x=7): on top at H2(y=15), gap where H1(y=9) is on top */}
      <path d="M7 3v4M7 11v10" />
      {/* Vertical strand 2 (x=17): on top at H1(y=9), gap where H2(y=15) is on top */}
      <path d="M17 3v10M17 17v4" />
    </svg>
  );
}

/**
 * WeaveIconBadge — the full-colour app-icon version (512×512 source geometry).
 * Use for logos, splash screens, or anywhere the Weave brand mark needs colour.
 */
export function WeaveIconBadge({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      className={className}
    >
      <defs>
        <linearGradient id="weave-bg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#6366F1" />
          <stop offset="1" stopColor="#8B5CF6" />
        </linearGradient>
        <filter id="weave-soft" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="6" stdDeviation="8" floodColor="#312E81" floodOpacity="0.28" />
        </filter>
      </defs>
      <rect x="0" y="0" width="512" height="512" rx="112" fill="url(#weave-bg)" />
      <g filter="url(#weave-soft)">
        {/* Horizontal strands */}
        <rect x="140" y="178" width="232" height="44" rx="22" fill="#FFFFFF" />
        <rect x="140" y="290" width="232" height="44" rx="22" fill="#FFFFFF" />
        {/* Vertical strands (over horizontals) */}
        <rect x="178" y="140" width="44" height="232" rx="22" fill="#FB7185" />
        <rect x="290" y="140" width="44" height="232" rx="22" fill="#FB7185" />
        {/* Re-lay horizontal "over" segments to create the interlace */}
        <rect x="282" y="178" width="60" height="44" rx="22" fill="#FFFFFF" />
        <rect x="170" y="290" width="60" height="44" rx="22" fill="#FFFFFF" />
      </g>
    </svg>
  );
}
